import { CommercialEvaluationRepository } from '@src/main/modules/reports/commercial/domain/commercial-evaluation.repository';

export const softDeleteCommercialEvaluation = async (
  repository: CommercialEvaluationRepository,
  evaluationId: string,
): Promise<void> => await repository.softDelete(evaluationId);
